import config from "lib/config";

export const isMangerViewingCoworker = () => {
  const selectedPersonalId = luvit.GetQueryString("id");
  return !!(selectedPersonalId && selectedPersonalId !== config.personalId);
};
